import { module } from 'stereomodularjs';
import gsap from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.container = this.el;
        this.cursor = this.el.querySelector('.js-cursor');

        if (!this.cursor) return;

        // Centrer le curseur (évite le décalage au chargement)
        gsap.set(this.cursor, { xPercent: -50, yPercent: -50 });
        gsap.set(this.cursor, { x: this.cursor.offsetWidth / 2, y: this.cursor.offsetHeight / 2 });

        let xTo = gsap.quickTo(this.cursor, "x", { duration: 0.45, ease: "power3" });
        let yTo = gsap.quickTo(this.cursor, "y", { duration: 0.45, ease: "power3" });

        let lastMouseX = null;
        let lastMouseY = null;

        const updateCursorPosition = (x, y) => {
            const rect = this.container.getBoundingClientRect();
            const cursor_rect = this.cursor.getBoundingClientRect();

            let newX = Math.min(
                Math.max(x - rect.left, cursor_rect.width / 2),
                rect.width - cursor_rect.width / 2
            );

            let newY = Math.min(
                Math.max(y - rect.top, cursor_rect.height / 2),
                rect.height - cursor_rect.height / 2
            );

            xTo(newX);
            yTo(newY);
        };

        this.container.addEventListener("mousemove", e => {
            lastMouseX = e.clientX;
            lastMouseY = e.clientY;
            updateCursorPosition(lastMouseX, lastMouseY);
        });

        this.container.addEventListener("mouseleave", () => {
            lastMouseX = null;
            lastMouseY = null;
            updateCursorPosition(0, 0);
        });
    }
}
